import { render, staticRenderFns } from "./Merchants.vue?vue&type=template&id=949254e0&scoped=true&lang=html&"
import script from "./Merchants.vue?vue&type=script&lang=js&"
export * from "./Merchants.vue?vue&type=script&lang=js&"
import style0 from "./Merchants.vue?vue&type=style&index=0&id=949254e0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949254e0",
  null
  
)

export default component.exports